<template>
  <section class="gt-page">
    <div class="gt-page-inner compact">
      <form class="gt-card form-card" @submit.prevent="createInvitation">
        <span class="gt-pill">Usuarios</span>
        <h1>Crear invitacion</h1>
        <p class="gt-muted">Genera un token para ligar un nuevo usuario a la empresa/sucursal seleccionada.</p>

        <label class="gt-label">Empresa activa</label>
        <input class="gt-input" :value="company?.name" disabled />

        <label class="gt-label">Sucursal</label>
        <select v-model="form.branch_token" class="gt-select">
          <option value="">Sin sucursal especifica</option>
          <option v-for="branch in branches" :key="branch.token" :value="branch.token">{{ branch.name }}</option>
        </select>

        <label class="gt-label">Rol</label>
        <select v-model="form.role_code" class="gt-select">
          <option value="company_user">Usuario</option>
          <option value="branch_manager">Encargado</option>
          <option value="warehouse_user">Almacenista</option>
          <option value="pos_cashier">Cajero</option>
          <option value="hr_employee">Empleado / comandero</option>
          <option value="company_admin">Admin Empresa</option>
        </select>

        <label class="gt-label">Correo destino</label>
        <input v-model.trim="form.email" class="gt-input" type="email" placeholder="Opcional" />

        <button class="gt-button primary" :disabled="loading || !company">Crear invitacion</button>
        <div v-if="invitation" class="result">
          <strong>Token:</strong>
          <code>{{ invitation.token }}</code>
          <strong>URL:</strong>
          <code>{{ invitation.registration_url }}</code>
        </div>
        <p v-if="error" class="error">{{ error }}</p>
      </form>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'InvitationsView',
  data() {
    return { loading: false, error: '', invitation: null, form: { branch_token: '', role_code: 'company_user', email: '' } };
  },
  computed: {
    company() { return this.$store.state.context?.company; },
    branches() { return this.$store.state.context?.branches || []; },
  },
  methods: {
    async createInvitation() {
      this.loading = true;
      this.error = '';
      this.invitation = null;
      try {
        const { data } = await api.post('/api/admin/invitations', {
          ...this.form,
          company_token: this.company.token,
        });
        this.invitation = data.invitation;
      } catch (error) {
        this.error = error.response?.data?.error || 'No se pudo crear la invitacion.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.compact { max-width: 760px; }
.form-card { padding: 2rem; display: grid; gap: .85rem; }
h1 { margin: .8rem 0 .25rem; font-size: 2.3rem; }
.result { display: grid; gap: .45rem; background: var(--gt-primary-soft); padding: 1rem; border-radius: 18px; }
code { overflow-wrap: anywhere; background: #fff; padding: .45rem .6rem; border-radius: 10px; }
.error { color: var(--gt-danger); font-weight: 800; }
</style>
